import {Injectable, NgZone} from '@angular/core';
import { CanActivate, CanLoad, Router } from '@angular/router';

import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class ContactGuard implements CanActivate, CanLoad {
  constructor(private modal: NgbModal, private zone: NgZone, protected router: Router) {}

  canActivate() { return this.loginGuard(); }
  canLoad() { return this.loginGuard(); }
  runRoute() {
    console.log("runRoute!");
    this.router.navigate(['/home']);
  }

  protected async loginGuard() {
    this.zone.runOutsideAngular(() => {      
      if (window['Usersnap']) {
        window['Usersnap']?.open()        
      } else {
        var refreshId = setInterval(() =>{
          if (window['Usersnap']) {
            console.log("interval clear!");
            window['Usersnap']?.open()
            clearInterval(refreshId);
          }
        }, 1000);
      }
    });
    this.runRoute();
    return false;
  }
}
